import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import ControlledSelect from '../../../shared/ControlledSelect'
import HiddenFieldMirror from '../../../shared/HiddenFieldMirror'
import TextInputError from '../../../shared/TextInputError'

const EDUCATION_LEVEL_OPTIONS = [
  { label: 'Some High School, No Degree', value: 'some_high_school' },
  { label: 'High School / GED', value: 'high_school' },
  { label: 'Some College, No Degree', value: 'some_college' },
  { label: 'Associate Degree', value: 'associate' },
  { label: "Bachelor's Degree", value: 'bachelors' },
  { label: "Master's Degree", value: 'masters' },
  { label: 'Doctorate', value: 'doctorate' },
  { label: 'Other', value: 'other' },
]

const FIELD_OF_STUDY_OPTIONS = [
  { label: 'Agriculture / Environmental Science', value: 'agriculture' },
  { label: 'Architecture / Urban Planning', value: 'architecture' },
  { label: 'Arts / Design / Performing Arts', value: 'arts' },
  { label: 'Biology / Life Sciences', value: 'biology' },
  { label: 'Business / Management', value: 'business' },
  { label: 'Chemistry / Physics', value: 'chemistry' },
  { label: 'Communications / Journalism', value: 'communications' },
  { label: 'Computer Science / IT', value: 'computer_science' },
  { label: 'Criminal Justice / Law Enforcement', value: 'criminal_justice' },
  { label: 'Culinary Arts / Hospitality', value: 'culinary' },
  { label: 'Economics', value: 'economics' },
  { label: 'Education / Teaching', value: 'education' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'English / Literature / Writing', value: 'english' },
  { label: 'Finance / Accounting', value: 'finance' },
  { label: 'Health Sciences / Nursing', value: 'health_sciences' },
  { label: 'History / Political Science', value: 'history' },
  { label: 'Law / Pre-Law', value: 'law' },
  { label: 'Liberal Arts / General Studies', value: 'liberal_arts' },
  { label: 'Mathematics / Statistics', value: 'mathematics' },
  { label: 'Medicine / Pre-Med', value: 'medicine' },
  { label: 'Philosophy / Religion', value: 'philosophy' },
  { label: 'Psychology', value: 'psychology' },
  { label: 'Social Work / Human Services', value: 'social_work' },
  { label: 'Sociology / Anthropology', value: 'sociology' },
  { label: 'Trade / Vocational Program', value: 'trade' },
  { label: 'Undecided / Exploratory', value: 'undecided' },
  { label: 'Other', value: 'other' },
]

const EducationBackground: FC = () => {
  const {
    formState: {
      errors: {
        educationLevel: educationLevelError,
        educationFieldOfStudy: educationFieldOfStudyError,
      },
    },
    clearErrors,
  } = useFormContext()

  return (
    <div className="col-span-full grid grid-cols-1 md:grid-cols-2 gap-6">
      <HiddenFieldMirror name="educationLevel" />
      <HiddenFieldMirror name="educationFieldOfStudy" />
      <div>
        <ControlledSelect
          id="education-level-select"
          name="educationLevel"
          label={EXTRA_QUESTION_LABELS.educationLevel}
          options={EDUCATION_LEVEL_OPTIONS}
          error={typeof educationLevelError?.message === 'string'}
          errorId="educationLevel-error"
          registerOptions={{
            onChange: () => {
              if (educationLevelError) clearErrors('educationLevel')
            },
          }}
        />
        {typeof educationLevelError?.message === 'string' && (
          <TextInputError id="educationLevel-error">This field is required</TextInputError>
        )}
      </div>
      <div>
        <ControlledSelect
          id="education-field-of-study-select"
          name="educationFieldOfStudy"
          label={EXTRA_QUESTION_LABELS.educationFieldOfStudy}
          options={FIELD_OF_STUDY_OPTIONS}
          error={typeof educationFieldOfStudyError?.message === 'string'}
          errorId="educationFieldOfStudy-error"
          registerOptions={{
            onChange: () => {
              if (educationFieldOfStudyError) clearErrors('educationFieldOfStudy')
            },
          }}
        />
        {typeof educationFieldOfStudyError?.message === 'string' && (
          <TextInputError id="educationFieldOfStudy-error">This field is required</TextInputError>
        )}
      </div>
    </div>
  )
}

export default EducationBackground
